export const HttpHeader = {
  WEB_API_KEY: 'Web-Api-Key',
  ACCEPT_LANGUAGE: 'Accept-Language',
  TRANSACTION_ID: 'transaction-id',
  CONTENT_TYPE: 'Content-Type'
}
